import BaseDataProvider from "./BaseDataProvider";
import { gql } from "apollo-boost";
import { getOffsetFromParams, getLimitFromParams } from "./utils";

class SchoolsDataProvider extends BaseDataProvider {
  async getList(resource, params) {
    console.log(
      "SchoolsDataProvider.getList(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    const offset = getOffsetFromParams(params);
    const limit = getLimitFromParams(params);
    const GET = gql`
          query {
            SchoolsSearch(
              name:"${params.filter.name ? params.filter.name : ""}"
              offset:${offset}
              limit:${limit}
            ) {
              offset
              limit
              total
              data {
                id
                stableId
                logoUrl
                name
                slug
                abbr
              }
            }
          }`;
    try {
      const response = await this.client.query({ query: GET });
      //console.log(JSON.stringify(response, null, 2));
      return response.data.SchoolsSearch;
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async getOne(resource, params) {
    console.log(
      "SchoolsDataProvider.getOne(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    const GET = gql`
          query {
            SchoolByID(id:"${params.id}") {
              id
              stableId
              logoUrl
              name
              slug
              abbr
            }
          }`;
    try {
      const response = await this.client.query({ query: GET });
      //console.log(JSON.stringify(response, null, 2));
      return { data: response.data.SchoolByID };
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async create(resource, params) {
    console.log(
      "SchoolsDataProvider.create(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    var objectString = JSON.stringify(params.data).replace(
      /"(\w+)"\s*:/g,
      "$1:"
    );
    objectString = objectString.substring(1, objectString.length - 1).trim();
    const CREATE_OBJECT = gql`
          mutation {
            CreateSchool(${objectString}) {
              id
              stableId
              logoUrl
              name
              slug
              abbr
            }
          }`;
    const response = await this.client.mutate({ mutation: CREATE_OBJECT });
    console.log(JSON.stringify(response, null, 2));
    return { data: response.data.CreateSchool };
  }

  async update(resource, params) {
    console.log(
      "SchoolsDataProvider.update(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    const objectInfo = JSON.parse(JSON.stringify(params.data));
    delete objectInfo.__typename;
    var objectString = JSON.stringify(objectInfo).replace(
      /"(\w+)"\s*:/g,
      "$1:"
    );
    objectString = objectString.substring(1, objectString.length - 1).trim();
    const MUTATION = gql`
          mutation {
            UpdateSchool(${objectString}) {
              id
              stableId
              logoUrl
              name
              slug
              abbr
            }
          }`;
    try {
      const response = await this.client.mutate({ mutation: MUTATION });
      //console.log(JSON.stringify(response, null, 2));
      return { data: response.data.UpdateSchool };
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async delete(resource, params) {
    console.log(
      "SchoolsDataProvider.delete(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    let infoString = JSON.stringify({ id: params.id }).replace(
      /"(\w+)"\s*:/g,
      "$1:"
    );
    infoString = infoString.substring(1, infoString.length - 1).trim();
    const DESTROY_OBJECT = gql`
            mutation {
              DeleteSchoolByID(${infoString})
            }`;
    const response = await this.client.mutate({ mutation: DESTROY_OBJECT });
    if (!response) throw new Error("BAD:", JSON.stringify(response));
    return { data: params.previousData };
  }
}

export default SchoolsDataProvider;
